import React from "react";
import * as S from "./styles";
import { LayoutTemplate } from "../LayoutTemplate";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../Atoms/Button";
import { useMediaQuery } from "react-responsive";
import CookieBannerPage from "../../Atoms/CookieBanner";
import { formatarTelefoneMascara, openWhatsApp } from "../../../utils/whatsapp";

const wp_caxias = "98985620425";
const wp_bacabal = "99984205510";
const wp_pinheiro = "99985355900";

export const HomeTemplate = () => {
  const isMobile = useMediaQuery({ maxWidth: "500px" });
  const navigate = useNavigate();

  return (
    <LayoutTemplate>
      <CookieBannerPage />
      <S.Container>
        <S.SectioStarCheck>
          <S.SectioStarCheckLeftSide>
            <S.SectioStarCheckLeftSideContent>
              <h1>
                Star{" "}
                <span>
                  Check{" "}
                  <img
                    src="assets/imgs/check-icon.svg"
                    alt="icone de checado"
                    className="inline-block ml-2"
                  />
                </span>
              </h1>

              <p>
                Sua empresa de Vistoria Veicular, especializada em análises de
                veículos, com foco em segurança e transparência.
              </p>

              <Button
                className="buttonAgendamento"
                data-variant-degrade
                onClick={() => navigate("agendamento")}
              >
                AGENDAR VISTORIA
              </Button>
            </S.SectioStarCheckLeftSideContent>
          </S.SectioStarCheckLeftSide>

          <S.SectioStarCheckRightSide>
            <S.SectioStarCheckRightSideContent>
              <img
                src={
                  isMobile
                    ? "assets/imgs/starcheck-mobile.png"
                    : "assets/imgs/starcheck.png"
                }
                alt="imagem mecanico"
              />
            </S.SectioStarCheckRightSideContent>
          </S.SectioStarCheckRightSide>
        </S.SectioStarCheck>

        <S.SectionAbout id="sobre">
          <S.SectionAboutContent>
            <S.Title>
              Sobre
              <span>
                Nós
                <img
                  src={"assets/imgs/check-icon.svg"}
                  alt="icone check"
                  className="ml-4 inline-block"
                />
              </span>
            </S.Title>
            <S.TextDefault>
              A <S.TextStrong>StarCheck</S.TextStrong> destaca-se pela sua{" "}
              <S.TextStrong>precisão</S.TextStrong>,{" "}
              <S.TextStrong>compromisso</S.TextStrong> com a{" "}
              <S.TextStrong>qualidade</S.TextStrong> e{" "}
              <S.TextStrong>atendimento excepcional</S.TextStrong> ao cliente.
              Valorizamos sua satisfação e nos esforçamos para superar suas
              expectativas. Nossa equipe está pronta para fornecer orientações
              especializadas e garantir que suas necessidades sejam atendidas de
              maneira eficiente.
            </S.TextDefault>
            <S.TextDefault>
              Seja de forma domiciliar ou em nossos pontos fixos, a{" "}
              <S.TextStrong>StarCheck </S.TextStrong>
              está pronta para ser sua parceira em todas as suas necessidades de
              vistorias veicular. Conte conosco para promover a segurança e
              proporcionar tranquilidade.
            </S.TextDefault>

            <Link to={"agendamento"}>
              <Button data-variant-degrade>AGENDAR VISTORIA</Button>
            </Link>

            <S.SectionCards>
              <S.WrapperCard>
                <S.SubTitle>Missão</S.SubTitle>
                <S.Card>
                  <p>
                    Contribuir para a segurança no mercado de{" "}
                    <S.TextBlue>veículos</S.TextBlue>, realizando vistorias
                    confiáveis ​​e precisas que garantem a tranquilidade para
                    você.
                  </p>
                </S.Card>
              </S.WrapperCard>

              <S.WrapperCard>
                <S.SubTitle>Visão</S.SubTitle>
                <S.Card>
                  <p>
                    Nosso propósito é ser referência em{" "}
                    <S.TextBlue>Vistoria Veicular</S.TextBlue>, destacando-nos
                    por excelência no serviço prestado.
                  </p>
                </S.Card>
              </S.WrapperCard>

              <S.WrapperCard>
                <S.SubTitle>Valores</S.SubTitle>
                <S.Card>
                  <S.Grid $gridTemplate=".2fr 1fr" $gap="16px">
                    <img
                      src="assets/imgs/check-icon.svg"
                      alt="icone de checado"
                    />
                    <h4>HONESTIDADE</h4>

                    <img
                      src="assets/imgs/check-icon.svg"
                      alt="icone de checado"
                    />
                    <h4>COMPROMETIMENTO</h4>

                    <img
                      src="assets/imgs/check-icon.svg"
                      alt="icone de checado"
                    />
                    <h4>RESPEITO</h4>

                    <img
                      src="assets/imgs/check-icon.svg"
                      alt="icone de checado"
                    />
                    <h4>CONFIANÇA</h4>
                  </S.Grid>
                </S.Card>
              </S.WrapperCard>
            </S.SectionCards>
          </S.SectionAboutContent>
        </S.SectionAbout>

        <S.SectionServices id="servicos">
          <S.SectionServicesContent>
            <S.Title className="flex gap-4">
              Serviços{}{" "}
              <img src="assets/imgs/check-icon.svg" alt="icone de checado" />
            </S.Title>
            <S.TextDefault>
              <S.TextStrong>Compre</S.TextStrong> e{" "}
              <S.TextStrong>agende online</S.TextStrong> sua vistoria conosco e
              tenha certeza da realização do serviço.
            </S.TextDefault>

            <S.TableService>
              <thead>
                <tr>
                  <td colSpan={2}>
                    <S.TableWrapperTitle>
                      <img
                        src="assets/imgs/pin-icon.svg"
                        alt="pin de localização"
                      />
                      <S.TitleTable>
                        Vistoria de Transferência / Primeiro Emplacamento{" "}
                        <S.TextBlue>Posto fixo</S.TextBlue>
                      </S.TitleTable>
                    </S.TableWrapperTitle>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h3>
                      R$ 152
                      {/* <span>**</span> */}
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <S.TableWrapperTitle>
                      <img
                        src="assets/imgs/mapa-icon.svg"
                        alt="pin de localização"
                      />
                      <S.TitleTable>
                        Vistoria de Transferência / Primeiro Emplacamento{" "}
                        <S.TextBlue>Domicilar</S.TextBlue>
                      </S.TitleTable>
                    </S.TableWrapperTitle>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={2}>
                    <h3>
                      R$ 190
                      {/* <span>**</span> */}
                    </h3>
                  </td>
                </tr>
              </tfoot>
            </S.TableService>

            {/* <S.Textplus>
              <S.TextRed>*</S.TextRed>Ônibus <S.TextBlue>-</S.TextBlue>{" "}
              Micro-ônibus <S.TextBlue>-</S.TextBlue> Reboque{" "}
              <S.TextBlue>-</S.TextBlue> Semirreboque <S.TextBlue>-</S.TextBlue>{" "}
              Caminhão <S.TextBlue>-</S.TextBlue> Caminhão Trator{" "}
              <S.TextBlue>-</S.TextBlue> Trator de Rodas{" "}
              <S.TextBlue>-</S.TextBlue> Trator Misto <S.TextBlue>-</S.TextBlue>{" "}
              Chassi/Plataforma
            </S.Textplus> */}
            {/* <S.Textplus>
              <S.TextRed>*</S.TextRed>
              <S.TextRed>*</S.TextRed>Taxa será acrescida no valor da compra.
              Taxa bancária no{" "}
              <S.TextStrong>Boleto</S.TextStrong> no valor de{" "}
              <S.TextBlue>R$ 3,92</S.TextBlue>.
            </S.Textplus> */}

            <Link to={"agendamento"}>
              <Button data-variant-degrade className="buttonAgendamento">
                AGENDAR VISTORIA
              </Button>
            </Link>
          </S.SectionServicesContent>
        </S.SectionServices>

        <S.SectionLocation id="localizacao">
          <S.SectionLocationContent>
            <S.Title className="flex gap-4">
              Localização{}{" "}
              <img src="/assets/imgs/check-icon.svg" alt="icone de checado" />
            </S.Title>

            <S.SectionLocationWrapperCardsMap>
              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/3qganLvjY8iNp78H7"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2038566.8520855648!2d-45.381611!3d-3.6835256!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7f68dc3febebcd9%3A0x26180aca863c765d!2sStarCheck!5e0!3m2!1spt-BR!2sbr!4v1777039279278!5m2!1spt-BR!2sbr"
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>

                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Calhau
                    <br /> São Luís / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Rua Chapadinha N.04 - Quadra 40,
                  <br />
                  <S.TextStrong> CEP 65072-852</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/HTcBheV2fhnrLcF38"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3978.986980950201!2d-44.787680699999996!3d-4.2227993999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x78a6f8c478ec937%3A0xc087eb9eef012568!2sStarCheck%20-%20Bacabal!5e0!3m2!1spt-BR!2sbr!4v1777039635009!5m2!1spt-BR!2sbr" 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Centro
                    <br /> Bacabal / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Br 316, S/N
                  <br />
                  <S.TextStrong> CEP 65700-000</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/g7gxmHjWWEwx1KQ79"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3955.5534005612185!2d-46.037939699999995!3d-7.514450600000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92d5ef004dced875%3A0xb2399ddbc8b9a0ff!2sStarcheck!5e0!3m2!1spt-BR!2sbr!4v1777039877054!5m2!1spt-BR!2sbr" 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Potosí
                    <br /> Balsas / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Av. Contorno N° 4144
                  <br />
                  <S.TextStrong>CEP 658000-000</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/5rZzM2ddHQEoNV8m6"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3985.918688429198!2d-45.0914751!3d-2.5334262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92b34f4a0d6079fd%3A0x50b56a16d596feba!2sStarcheck!5e0!3m2!1spt-BR!2sbr!4v1777040050890!5m2!1spt-BR!2sbr" 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    São Castelo
                    <br /> Pinheiro / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Estr. das Cotias, S/N
                  <br /> 
                  <S.TextStrong>CEP 65200-000</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/mMq6VjbKrqcLegLRA"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.37023063822!2d-43.338870924770866!3d-4.877501695098235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x78e93c7751bf131%3A0xf63a99f4f57c5852!2sStarCheck%20Caxias!5e0!3m2!1spt-BR!2sus!4v1777040350990!5m2!1spt-BR!2sus" 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Bela Vista
                    <br /> Caxias / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Rodovia BR-316, Km 554
                  <br /> <S.TextStrong>CEP 65605-295</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://maps.app.goo.gl/t8N61r7QjsYkA6W98"
                >
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3977.675944706341!2d-43.8941346!3d-4.4711897999999985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x78bf1607a5ac3fb%3A0xcbe5e588e35ddf4f!2sStarCheck%20-%20Cod%C3%B3!5e0!3m2!1spt-BR!2sbr!4v1777040510197!5m2!1spt-BR!2sbr" 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Santa Lúcia
                    <br /> Codó / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  R. São Luís, 1600
                  <br /> <S.TextStrong>CEP 65400-00</S.TextStrong>
                </p>
              </S.SectionLocationCardMap>

              {/* <S.SectionLocationCardMap>
                <S.WrapperImgMap
                  target="_blank"
                  href="https://www.google.com.br/maps/place/7%C2%B021'46.6%22S+46%C2%B037'21.5%22W/@-7.3630442,-46.6229281,19z/data=!4m4!3m3!8m2!3d-7.362956!4d-46.62264?entry=ttu"
                >
                  <img src="/assets/imgs/map7.svg" alt="mapa de sao luiz" />
                </S.WrapperImgMap>
                <S.TitleLocalization>
                  <img src="/assets/imgs/pin-blue-icon.svg" alt="pin do mapa" />
                  <span>
                    Bela Vista
                    <br /> Riachão / MA
                  </span>
                </S.TitleLocalization>
                <p>
                  Rua 31 de Dezembro, N188
                  <br /> <S.TextStrong>CEP 65990-000</S.TextStrong>
                </p>
              </S.SectionLocationCardMap> */}
            </S.SectionLocationWrapperCardsMap>
          </S.SectionLocationContent>
        </S.SectionLocation>

        <S.SectionContact id="contato">
          <S.SectionContactContent>
            <h1 className="flex gap-4">
              Contatos{" "}
              <img
                src="/assets/imgs/check-dark-blue.svg"
                alt="icone de checado"
              />
            </h1>

            <div>
              <S.TitleLocalization>
                <span>Caxias / MA</span>
              </S.TitleLocalization>
              <S.TitleLocalization>
                <span>São Luis / MA</span>
              </S.TitleLocalization>

              <button onClick={() => openWhatsApp(wp_caxias)}>
                <p className="flex gap-2">
                  <img
                    src="/assets/imgs/icon-whatsapp.svg"
                    alt="icone whatsapp"
                  />
                  {formatarTelefoneMascara(wp_caxias)}
                </p>
              </button>
            </div>

            <div>
              <S.TitleLocalization>
                <span>Codó / MA</span>
              </S.TitleLocalization>
              <S.TitleLocalization>
                <span>Bacabal / MA</span>
              </S.TitleLocalization>

              <button onClick={() => openWhatsApp(wp_bacabal)}>
                <p className="flex gap-2">
                  <img
                    src="/assets/imgs/icon-whatsapp.svg"
                    alt="icone whatsapp"
                  />
                  {formatarTelefoneMascara(wp_bacabal)}
                </p>
              </button>
            </div>

            <div>
              <S.TitleLocalization>
                <span>Pinheiro /MA</span>
              </S.TitleLocalization>
              {/* <S.TitleLocalization>
                <span>Riachão / MA</span>
              </S.TitleLocalization> */}
              <S.TitleLocalization>
                <span>Balsas / MA</span>
              </S.TitleLocalization>
              <button onClick={() => openWhatsApp(wp_pinheiro)}>
                <p className="flex gap-2">
                  <img
                    src="/assets/imgs/icon-whatsapp.svg"
                    alt="icone whatsapp"
                  />
                  {formatarTelefoneMascara(wp_pinheiro)}
                </p>
              </button>
            </div>
          </S.SectionContactContent>
        </S.SectionContact>
      </S.Container>
    </LayoutTemplate>
  );
};
